import { useContext, useEffect, useState } from 'react';
import auxService from '../services/AuxService';
import { format } from "date-fns";
import { faCancel, faCheck, faClock, faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { AuthContext } from '../contexts/AuthContext';
interface totais {
    encerrados: number;
    cancelados: number;
    transmitidos: number;
    falta_encerragar: number
}

const initState: totais = {
    cancelados: 0,
    encerrados: 0,
    falta_encerragar: 0,
    transmitidos: 0
}


export default function Dashboard() {
    const authContext = useContext(AuthContext);
    const empresa = authContext?.empresa;
    const [data, setData] = useState<totais>(initState);
    useEffect(() => {
        auxService.getHome().then(res => {
            if (res?.data) {
                setData(res.data)
            }
        });
    }, [empresa])

    return (
        <>
            <div className='row g-2'>
                <div className='col-md-3'>
                    <div className="small-box bg-warning text-lg-start text-center">
                        <div className="inner">
                            <h3>{data.falta_encerragar}</h3>
                            <p><FontAwesomeIcon icon={faClock} /> Manifesto para serem encerrados</p>
                        </div>

                    </div>
                </div>
                <div className="col-md-3">
                    <div className="small-box bg-success text-lg-start text-center">
                        <div className="inner">
                            <h3>{data.transmitidos}</h3>
                            <p><FontAwesomeIcon icon={faEnvelope} /> Manifestos Transmitido </p>

                        </div>
                    </div>
                </div>
                <div className="col-md-3">

                    <div className="small-box bg-info2 text-lg-start text-center">
                        <div className="inner">
                            <h3>{data.encerrados}</h3>
                            <p><FontAwesomeIcon icon={faCheck} /> Manifestos Encerrados em: {format(new Date(), 'MM/Y')} </p>
                        </div>
                    </div>
                </div>

                <div className="col-md-3">
                    <div className="small-box bg-danger text-lg-start text-center">
                        <div className="inner">
                            <h3>{data.cancelados}</h3>
                            <p><FontAwesomeIcon icon={faCancel} /> Manifestos Cancelados em: {format(new Date(), 'MM/Y')} </p>
                        </div>
                    </div>
                </div>
            </div>

            <footer
                className={`fixed-bottom d-flex justify-content-between py-1 pe-1 px-2 
                 `}>


                <div className="d-none d-md-block">
                    © {new Date().getFullYear().toString()} PlugSystem | Todos os direitos reservados.
                </div>

                {authContext?.empresas && (
                    <div className="d-none d-md-block">
                        {authContext?.empresas.filter(e => e.id.toString() === empresa?.toString()).map((empresa) => (
                            <span className="px-2 rounded-1 fw-bold fs-6 text-center d-flex align-items-center" >
                                {empresa.xfant} - {
                                    empresa.cpfcnpj
                                        .replace(/\D/ig, '')
                                        .replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, '$1.$2.$3/$4-$5')
                                }
                            </span>
                        ))}
                    </div>
                )}


            </footer>
        </>);
};
